import React from "react";
import ProductCard from "./ProductCard";
import { motion } from "framer-motion";

const BestSeller = ({ products, addToCart, addedItems, categories }) => {
  return (
    <section className="container my-5 py-4">
      <div className="section_header mb-5">
        <div className="d-flex align-items-center justify-content-between">
          <div className="title-area">
            <h2 className="h3 fw-800 mb-1" style={{ color: "#1a1a1a", fontWeight: 800 }}>
              Best Sellers
            </h2>
            <p className="text-muted small mb-0">Our most wanted products from the collection</p>
          </div>
          <div className="header-line flex-grow-1 mx-4 d-none d-md-block" style={{ height: '1px', background: '#eee' }}></div>
        </div>
      </div>

      <div className="row g-4">
        {products && products.length > 0 ? (
          products.slice(0, 4).map((item, index) => (
            <motion.div
              key={item._id}
              className="col-6 col-sm-6 col-md-4 col-lg-3"
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <ProductCard
                categories={categories}
                item={item}
                addToCart={addToCart}
                isAdded={addedItems.includes(item._id)}
              />
            </motion.div>
          ))
        ) : (
          <div className="col-12 text-center py-5">
            <p className="text-muted">Explore our full catalog to see more.</p>
          </div>
        )}
      </div>
    </section>
  );
};


export default BestSeller;

